<script>
  import { onMount } from "svelte";
  let { item } = $props();
  function open(item) {
    const lightbox = new FsLightbox();
    let images = item.gallery.images;
    let sources = [];
    images.forEach((img) => {
      sources.push(img.url);
    });
    // set up props, like sources, types, events etc.
    lightbox.props.sources = sources;
    lightbox.props.onInit = () => console.log("Lightbox initialized!");

    lightbox.open();
  }
</script>

<div class="gallery-item -gallery">
  <span
    onclick={open(item)}
    class="gallery-mode icon gallery-icon"
    aria-hidden="open gallery"
  ></span>
</div>
